import common from "@page/common/js/common";
import modal from "bootstrap/js/dist/modal";
import NewImage from "@global/components/global/image";
import LOOKBOOKPOPUP_TMPL from "@page/lookbook/js/lookbookPopupTmpl";
import INDEX_TMPL from "@page/lookbook/js/indexTmpl";
import ITEM_TMPL from "@page/lookbook/js/itemTmpl";

const shopItem = {
  template: ITEM_TMPL,
  props: ["item"],
  data: function () {
    return {
      size: "SELECT A SIZE",
    };
  },
  components: {
    NewImage,
  },
  watch: {
    size: function (val) {
      const _this = this;
      // this.$emit("updateselected", {id: _this.item.CustomMarketID, cuid: val});
    },
  },
  created: function () {},
};

const lookPopup = {
  template: LOOKBOOKPOPUP_TMPL,
  props: ["item", "tagname", "isopen", "link", "igimg"],
  data: function () {
    return {
      selected: [],
    };
  },
  components: {
    shopItem,
  },
  mounted: function () {},
  methods: {
    closePopup: function () {
      this.selected = [];
      this.$emit("close");
    },
    addtocart: function () {
      this.$emit("addtocart", $(this.$el).find(".product-size-select option:selected"));
    },
  },
};

const app = new Vue({
  el: "#lookbook-app",
  template: INDEX_TMPL,
  data: {
    nowPopupID: null, //for popup show/off,
    popupPost: null,
    popupIsOpen: false,
    posts: [],
    isLoading: false,
    runLoading: false,
    dataisload: false,
    slideEl: "#slide-lookbook",
    nowActive: "",
    campaigns: window.IGCampaigns,
    activeCampaign: "",
    igImg: "",
  },
  components: { lookPopup, NewImage, shopItem },
  created: function () {
    this.getCampaign();
  },
  methods: {
    slideShow: function (el) {
      const $el = $(el);
      const $img = $el.find(".slide-item img");
      const $item = $el.find(".slide-item");
      const $content = $el.find(".slide-content");
      const slideWidth = $el.find(".slide-wrap").outerWidth();
      const $bar = $el.find(".process-bar");
      const maxLen = $img.length;
      const imgRatio = 0.8;

      let nowIdx = 0;
      let nowPosition = 0;

      $content.css({ width: slideWidth * imgRatio * maxLen, transform: `translate3d(0px, 0px, 0px)` });
      $bar.css({ width: (1 / maxLen) * 100 + "%", left: "0%" });
      $item.css("width", slideWidth * imgRatio);
      $item.css("padding-right", "50px");

      $el.unbind("mousewheel");
      $el.unbind("DOMMouseScroll");

      setTimeout(() => {
        this.runLoading = true;
      }, 1000);

      function init() {
        let nowIdx = 0;
        let nowPosition = 0;
        $el.bind("mousewheel", function (e) {
          if (e.originalEvent.wheelDelta < 0) {
            //scroll down
            if (nowPosition > -slideWidth * imgRatio * (maxLen - 1)) {
              nowPosition -= slideWidth * imgRatio;
              nowIdx++;

              nowPosition < -slideWidth * imgRatio * (maxLen - 1)
                ? (nowPosition = -slideWidth * imgRatio * (maxLen - 1))
                : nowPosition;
              nowIdx > maxLen - 1 ? (nowIdx = maxLen - 1) : nowIdx;
            }
          } else {
            //scroll up

            if (nowPosition < 0) {
              nowPosition += slideWidth * imgRatio;
              nowIdx--;

              nowPosition > 0 ? (nowPosition = 0) : nowPosition;
              nowIdx < 0 ? (nowIdx = 0) : nowIdx;
            }
          }
          $bar.css("left", (1 / maxLen) * 100 * nowIdx + "%");
          $content.css({
            width: slideWidth * imgRatio * maxLen,
            transform: `translate3d(${nowPosition}px, 0px, 0px)`,
          });

          //prevent page fom scrolling
          return false;
        });

        // firefox
        $el.bind("DOMMouseScroll", function (e) {
          if (e.originalEvent.detail > 0) {
            //scroll down
            if (nowPosition > -slideWidth * imgRatio * (maxLen - 1)) {
              nowPosition -= slideWidth * imgRatio;
              nowIdx++;
              nowPosition < -slideWidth * imgRatio * (maxLen - 1)
                ? (nowPosition = -slideWidth * imgRatio * (maxLen - 1))
                : nowPosition;
              nowIdx > maxLen - 1 ? (nowIdx = maxLen - 1) : nowIdx;
            }
          } else {
            //scroll up
            if (nowPosition < 0) {
              nowPosition += slideWidth * imgRatio;
              nowIdx--;
              nowPosition > 0 ? (nowPosition = 0) : nowPosition;
              nowIdx < 0 ? (nowIdx = 0) : nowIdx;
            }
          }
          $bar.css("left", (1 / maxLen) * 100 * nowIdx + "%");
          $content.css({
            width: slideWidth * imgRatio * maxLen,
            transform: `translate3d(${nowPosition}px, 0px, 0px)`,
          });
          //prevent page fom scrolling
          return false;
        });
      }

      init();
    },
    getCampaign: function () {
      var _this = this;
      var campaignTag = this.getTagName();
      $.ajax({
        type: "GET",
        url: API_URL.IG_STYLE + "?Tag=" + campaignTag,
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        error: function () {
          console.log("error");
        },
        success: function (res) {
          if (res.Code === 200) {
            _this.posts = res.Response.Posts;

            _this.posts.forEach(function (element, index) {
              element.showShopList = false;
            });

            _this.dataisload = true;

            _this.runLoading = true;
            // _this.$nextTick(function () {
            // 	_this.slideShow(_this.slideEl)
            // })
          } else {
            AlertDialog.alert("系統忙線中，請稍後");
          }
        },
      });
    },
    getTagName: function () {
      var pathname = window.location.pathname;
      if (pathname.substring(pathname.indexOf("ig/") + 3, pathname.length).indexOf("/") !== -1) {
        var tagName = pathname.substring(pathname.indexOf("ig/") + 3, pathname.lastIndexOf("/"));
      } else {
        var tagName = pathname.substring(pathname.indexOf("ig/") + 3, pathname.length);
      }
      return tagName;
    },
    changeCampaign: function (idx) {
      if (!this.runLoading) return;
      this.runLoading = false;
      this.getCampaign(this.campaigns[idx].ShowTag.substr(1));
    },
    getShopList: function (str, idx) {
      const _this = this;

      $.ajax({
        type: "GET",
        url: API_URL.IG_DETAILS + "?CustomMarketIDs=" + str,
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        error: function () {
          console.log("error");
        },
        success: function (res) {
          if (res.Code === 200) {
            _this.popupPost = res.Response;

            if (window.innerWidth <= 800) {
              // mobile展開區塊
              _this.posts.forEach(function (element, index) {
                element.showShopList = false;
              });
              _this.posts[idx].showShopList = true;
            } else {
              // pc開popup
              _this.popupIsOpen = true;
            }
          } else {
            AlertDialog.alert("系統忙線中，請稍後");
          }
        },
      });
    },
    openPopup: function (index, pid, igImg) {
      const arr = [];

      this.posts[index].MarketColors.forEach(function (element, index) {
        arr.push(`MT1M${element.MarketID}CL${element.ProductColorID}SZ_`);
      });

      if (arr.length === 0) {
        AlertDialog.alert("尚無商品");
        return; //沒有商品
      }

      if (pid === this.nowActive) return;

      this.igImg = igImg;

      this.nowActive = pid;

      this.getShopList(arr.join(), index);
    },
    closePopup: function () {
      this.$nextTick(function () {
        $("#lookbook-popup").modal("hide");
      });
      this.popupIsOpen = false;
      this.popupPost = [];
      this.nowActive = "";
    },
    addCart: function ($selector) {
      const arr = [];
      let isSelected = false;

      $selector.each(function (index, el) {
        if ($(el).val() !== "SELECT A SIZE") {
          isSelected = true;
          arr.push($(el).val());
        }
      });

      if (!isSelected) {
        AlertDialog.alert("Please select a size.");
      } else {
        this.callCartApi(arr);
      }
    },
    callCartApi: function (arr) {
      const _this = this;
      const len = arr.length;
      let n = 0;

      call();

      function call() {
        $.ajax({
          type: "POST",
          url: API_URL.SHOPPING_CART,
          dataType: "json",
          data: "CustomMarketID=" + arr[n] + "&Count=1",
          xhrFields: {
            withCredentials: true,
          },
          error: function () {
            console.log("error");
          },
          success: function (res) {
            if (res.Code === 200) {
              n++;
              if (n < len) {
                call();
              } else {
                appNotificationCart.getShoppingDatas();
              }
            } else {
              AlertDialog.alert("系統忙線中，請稍後");
            }
          },
        });
      }
    },
  },
});
